import styled from "..";

interface IWrapperInputText {
  focused?: boolean;
}

const WrapperInput = styled("div")<IWrapperInputText>`
  font-weight: ${(props) => props.theme.fonts.fontLight};
  color: ${(props) => props.theme.colors.colorGray()};
  position: relative;
  border: 1px solid
    ${(props) =>
      props.focused
        ? props.theme.colors.colorPrimary()
        : props.theme.colors.colorGrayLight()};
  border-radius: ${(props) => props.theme.radius.defaultRadius};
  margin-bottom: ${(props) => props.theme.spacing.defaultSpacing(1)};
  transition: ${(props) => props.theme.transitions.transitionDefault};
  text-align: left;
  max-height: 30vh;
`;

export { WrapperInput };
